import { API_URL } from "constants/api";
import { useAuth } from "providers/auth";
import { useEffect, useState } from "react";

type CountResponse = { count?: number };

export const useOpenSupportTicketsCount = () => {
  const [count, setCount] = useState(0);
  const { user } = useAuth();

  useEffect(() => {
    fetch(`${API_URL}admin/support-tickets?status=created&limit=1`, {
      headers: { Authorization: `bearer ${user?.token}` },
    })
      .then((x) => x.json())
      .then((res: CountResponse) => setCount(res.count ?? 0))
      .catch(() => setCount(0));
  }, [user?.token]);

  return count;
};
